import { ReactNode } from "react";
import { FooterContainer, FooterContent } from "./styles";

interface FooterProps {
  children: ReactNode;
  justifyContent?: "flex-end" | "center" | "space-between";
}

export const Footer = ({ children, justifyContent }: FooterProps) => {
  return (
    <FooterContainer>
      <FooterContent justifyContent={justifyContent}>{children}</FooterContent>
    </FooterContainer>
  );
};
